<template>
  <div class="about">
    <div class="content">
    <h1>Kontakt oss</h1>
    <div class="aboutInfoBox">
      <h3>Knerten Familiebarnehage sin adresse</h3>
      <h4>Adresse: {{ adresse }}</h4>
      <h4>Postnummer: {{ postNr }}</h4>
      
      <h3><br> Kontaktperson </h3>
      <h4>Styrer: {{ styrer }}</h4>
      <h4>Telefon nummer: {{ tlfNr }}</h4>
      <h4>E-post: {{ epost }}</h4>
      <div class="push"></div>
    </div>
    </div>
  
      <GmapMap
        v-bind:center="center"
        :zoom="15"
        map-type-id="roadmap"
        style="width: auto; height: 300px;"
      >
        <GmapMarker
          :key="index"
          v-for="(m, index) in markers"
          :position="m.position"
          :clickable="true"
          :draggable="true"
        />
      </GmapMap>

    
  </div>
</template>

<script>
export default {
  data() {
    return {
      center: {lat:	59.4132867, lng:10.2805462},
      markers: [{
        position: {lat:59.4132867, lng:10.2805462}
      }],
      adresse: "Brekkeåsveien 28",
      postNr: "3178 Våle",
      styrer: "Bente C. W. Strøm",
      tlfNr: 95892360,
      epost: "bente@knertenbarnehage.com"

    }
  },
}
</script>

<style scoped>
/* .content {
  padding: 20px;
  min-height: calc(100vh - 75px);
  margin: 0 auto -300px;
} */

.aboutInfoBox {
  text-align: left;
  margin-top: 1%;
  margin-left: 10%;
  /* margin-bottom: 2%; */
}

.footer,
.push {
  height: 300px;
}
@media screen and (min-width: 1001px) {
  h3 {
    font-weight: bold;
    font-size:1.6vw;
  }
  h4 {
    font-size:1.25vw;
    margin-bottom: 0%;
  }
  .content {
  padding: 20px;
  min-height: calc(100vh - 75px);
  margin: 0 auto -300px;
  }
}

@media screen and (max-width: 1000px) {
  h3 {
    font-weight: bold;
    font-size:3.6vw;
  }
  h4 {
    font-size:3.25vw;
    margin-bottom: 0%;
  }
  .content {
  padding: 20px;
  min-height: calc(77vh);
  margin: 0 auto -300px;
  }
}
</style>

